










































































import { Component, Vue } from "vue-property-decorator";
import { ComponentsTypes } from "@/components/DinamicallyForm/TipoComponentes";

interface ComponentDef {
  type: ComponentsTypes;
  label: string;
  icon: string;
  color: string;
  description: string;
}

@Component
export default class ComponentPalette extends Vue {
  public textComponents: ComponentDef[] = [
    {
      type: ComponentsTypes.TextBox,
      label: "Campo de Texto",
      icon: "mdi-form-textbox",
      color: "blue",
      description: "Input de texto simple",
    },
    {
      type: ComponentsTypes.TextArea,
      label: "Área de Texto",
      icon: "mdi-text-box-outline",
      color: "indigo",
      description: "Textarea multilínea",
    },
  ];

  public selectorComponents: ComponentDef[] = [
    {
      type: ComponentsTypes.SingleCombo,
      label: "Selección Simple",
      icon: "mdi-form-dropdown",
      color: "green",
      description: "Dropdown de selección única",
    },
    {
      type: ComponentsTypes.MultiCombo,
      label: "Selección Múltiple",
      icon: "mdi-form-select",
      color: "teal",
      description: "Dropdown multiselección",
    },
    {
      type: ComponentsTypes.RadioButton,
      label: "Radio Buttons",
      icon: "mdi-radiobox-marked",
      color: "purple",
      description: "Botones de opción",
    },
    {
      type: ComponentsTypes.Switch,
      label: "Interruptor",
      icon: "mdi-toggle-switch",
      color: "orange",
      description: "Switch boolean",
    },
  ];

  public otherComponents: ComponentDef[] = [
    {
      type: ComponentsTypes.Date,
      label: "Fecha",
      icon: "mdi-calendar",
      color: "red",
      description: "Selector de fecha",
    },
    {
      type: ComponentsTypes.DateTime,
      label: "Fecha y Hora",
      icon: "mdi-calendar-clock",
      color: "deep-orange",
      description: "Selector de fecha y hora",
    },
    {
      type: ComponentsTypes.TablaCodigoDescripcion,
      label: "Código-Descripción",
      icon: "mdi-table-search",
      color: "cyan",
      description: "Tabla código-descripción",
    },
    {
      type: ComponentsTypes.Slot,
      label: "Slot Personalizado",
      icon: "mdi-puzzle",
      color: "grey",
      description: "Componente custom",
    },
  ];

  public onDragStart(componentType: ComponentsTypes) {
    this.$emit("drag-start", componentType);
  }
}
